import { $httpFhirApi } from '@/common/api/httpFhir.service';

export const isSelfPayCoverage = (coverage) => !!coverage?.type?.coding?.some((coding) => coding.system === 'http://terminology.hl7.org/CodeSystem/coverage-selfpay' && coding.code === 'pay');

const statusSortValues = { active: 1, draft: 2, cancelled: 3, 'entered-in-error': 4 };
export const prioritySortValues = { P: 1, S: 2, T: 3, A: 4, U: 5 };

// The order coverages are listed in everywhere they appear: by status, then insurance priority, then
// payer name. The Coverage queries carry no _sort, so without it a just-saved coverage comes back last.
export const compareCoverages = (a, b) =>
    statusSortValues[a.status] - statusSortValues[b.status] ||
    prioritySortValues[a.insurancePriority?.coding?.[0]?.code] - prioritySortValues[b.insurancePriority?.coding?.[0]?.code] ||
    (a.payor?.[0]?.display > b.payor?.[0]?.display ? 1 : b.payor?.[0]?.display > a.payor?.[0]?.display ? -1 : 0);

// The self-pay record the Coverage card and the Insurance coverage widget both write, so either one
// reads the other's. `payer` is the account's self-pay Organization when one is configured.
export const selfPayCoverageJson = (patientId, payer) => ({
    resourceType: 'Coverage',
    beneficiary: { id: patientId, resourceType: 'Patient' },
    status: 'active',
    type: { coding: [{ code: 'pay', system: 'http://terminology.hl7.org/CodeSystem/coverage-selfpay', display: 'Self pay' }] },
    relationship: { coding: [{ code: '18', system: 'http://code.system/relationship-types', display: 'Self' }] },
    period: { start: new Date().toISOString().slice(0, 10) },
    payor: [payer ? { display: payer.name, uri: `collaboratemd://payer/${payer.payerId}` } : { display: 'Self pay' }],
    subscriberId: 'SELF',
    acceptAssignment: 'yes',
    patientOrAuthorizedSignature: 'yes',
    insurancePriority: { coding: [{ code: 'P', system: 'http://code.system/insurance-priority', display: 'Primary' }] },
});

export const isSelfPayPayer = (organization) => organization?.resourceType === 'Organization' && organization.active === true && !!organization.name?.toLowerCase().includes('self pay');

// The account's self-pay payer Organization, or undefined when none is configured or the lookup fails;
// selfPayCoverageJson falls back to a plain "Self pay" payer then.
export const fetchSelfPayPayer = async () => {
    try {
        const response = await $httpFhirApi.get('Organization?type=pay&active=true&name:contains=' + encodeURIComponent('self pay'));
        return (response?.data ?? []).find(isSelfPayPayer);
    } catch (error) {
        console.error('[coverage] could not look up the self-pay payer', error);
    }
};
